import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {Body, H6} from "@irati/ui/src/Typography"

const StepOne: FC = () => {
  const boldText = (
    <Body small weight="bold">
      <FormattedMessage id="platform.home.tour.stepOne.preview.boldText" />
    </Body>
  )

  return (
    <>
      <H6 width="90%" marginBottom>
        <FormattedMessage id="platform.home.tour.stepOne.preview.header" />
      </H6>
      <Body small>
        <FormattedMessage id="platform.home.tour.stepOne.preview.desc" values={{boldText}} />
      </Body>
    </>
  )
}

export default StepOne
